import {GET_ROBOTS_AND_VEHICLES_SUCCESS} from "../../../reducers/robotsAndVehiclesReducer";


export const getRobotsSuccess = (robots, replaceExisting, statistics) =>{
    return {
        type: GET_ROBOTS_AND_VEHICLES_SUCCESS,
        payload: {robots, replaceExisting, statistics}
    }
}